import { __exportAll } from "../../../_virtual/_rolldown/runtime.js";
import { createElementBlock, createElementVNode, openBlock } from "vue";
//#region src/components/ScalarIcon/icons/Info.svg?component
var Info_exports = /* @__PURE__ */ __exportAll({
	default: () => Info_default,
	render: () => render$1
});
var _hoisted_1 = {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 24 24"
};
function render$1(_ctx, _cache) {
	return openBlock(), createElementBlock("svg", _hoisted_1, [..._cache[0] || (_cache[0] = [
		createElementVNode("path", {
			stroke: "currentColor",
			"stroke-linecap": "round",
			"stroke-linejoin": "round",
			d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10"
		}, null, -1),
		createElementVNode("path", {
			stroke: "currentColor",
			"stroke-linecap": "round",
			"stroke-linejoin": "round",
			d: "M12 17v-6 0a.5.5 0 0 0-.5-.5l-.5.001h-1M12 17h-2m2 0h2"
		}, null, -1),
		createElementVNode("path", {
			fill: "currentColor",
			"fill-rule": "evenodd",
			d: "M10.75 7.5a1 1 0 1 1 2 0 1 1 0 0 1-2 0",
			"clip-rule": "evenodd"
		}, null, -1)
	])]);
}
var Info_default = { render: render$1 };
//#endregion
export { Info_exports, Info_default as default, render$1 as render };

//# sourceMappingURL=Info.svg_component.js.map